function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import clone from 'ramda/src/clone';
import pathOr from 'ramda/src/pathOr';
import i18n from 'invision-core/src/components/i18n/i18n';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { hasReadAccess } from 'invision-core/src/components/security/permission.service';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { formHasErrors } from 'invision-core/src/components/helpers/form.helper';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import CustomerCareKeys from '../../../../locales/keys';
import { NOTIFICATION_TIME_LENGTH } from '../../../../customercare.constants';
import { CREDIT_CHECK_RESULT_SUCCESS_STATUS, CREDIT_CHECK_STATUS } from '../../../../reducers/constants/credit.check.constants';
// Should not be importing files from a specific wizard here, this can be passed in. Will be fixed in ASCINV-319
import { DriversLicenseStateRegionProvinceValueOptions, StateRegionProvinceValueOptions } from '../../../wizards/newConnectWizard/new.connect.wizard.selectors';
import { EditCartSelector, IsCreatingOrUpdatingCustomerSelector } from '../../../../reducers/selectors/new.connect.wizard.selectors';
import { updateCustomerInfo, updateCustomerInfoEditCopy } from '../../../../reducers/actions/new.connect.wizard.actions';
import { createOrUpdateCustomerAndRunCreditCheck, overrideCreditClassification, setCreditCheckModalStatus, setCreditCheckSkipped } from '../../../../reducers/actions/credit.check.actions';
import { getErrorLookupObject } from '../../../createCustomer/create.customer.constants';
import { apFormHasErrors } from '../../../main/customercare.page.helper';
import { CanUserOverrideCreditCheckSelector, CreditCheckClassificationOptionsSelector, CreditCheckConfigurationSelector, CreditClassificationsSelector, RunCreditCheckErrorMessageSelector, SubscriberCreditCheckAddressStatesOptions, SubscriberCreditCheckDetailsSelector, SubscriberCreditCheckStatusSelector, SubscriberIsUpdatingCreditClassificationSelector } from '../../../../reducers/selectors/credit.check.selectors';
import { transformAddressResponseObjectForEditing } from '../../../../reducers/helpers/customer.helper';
import { createEditCustomerFormChanged } from '../../../../reducers/actions/customer.actions';
import { CreateEditCustomerSelector, SelectedCustomerCreditCheckDetailsSelector } from '../../../../reducers/selectors/customer.selectors';
import { setForceShowEditFormAddress, validateAddress } from '../../../../reducers/actions/address.component.actions';
import { UnvalidatedAddressesSelector, ValidatedAddressesSelector } from '../../../../reducers/selectors/address.component.selectors';
import { isAddressValidFromAddressResponse } from '../../../shared/contextualComponents/address/address.validator.helper';
import { CREDIT_CLASS_VIEW_ACCESS } from '../../../../security.attributes';
var mapStateToTarget = function mapStateToTarget(store) {
  return {
    addressCountriesLoaded: MetadataCodeLoadedSelector(CODES.AddressCountry, store),
    addressStatesLoaded: MetadataCodeLoadedSelector(CODES.AddressStateProvinceRegion, store),
    addressStatesOptions: StateRegionProvinceValueOptions(store),
    canOverrideCreditCheckClassification: CanUserOverrideCreditCheckSelector(store),
    createEditCustomer: CreateEditCustomerSelector(store),
    creditCheckClassificationOptions: CreditCheckClassificationOptionsSelector(store),
    creditCheckConfiguration: CreditCheckConfigurationSelector(store),
    creditClassifications: CreditClassificationsSelector(store),
    driversLicenseStateOptions: DriversLicenseStateRegionProvinceValueOptions(store),
    editCartSelector: EditCartSelector(store),
    isCreatingCustomer: IsCreatingOrUpdatingCustomerSelector(store),
    isDbss: IsDbss(store),
    isUpdatingCreditClassification: SubscriberIsUpdatingCreditClassificationSelector(store),
    runCreditCheckErrorMessage: RunCreditCheckErrorMessageSelector(store),
    selectedCustomerCreditCheckDetails: SelectedCustomerCreditCheckDetailsSelector(store),
    subscriberAddressStatesOptions: SubscriberCreditCheckAddressStatesOptions(store),
    subscriberCreditCheckDetails: SubscriberCreditCheckDetailsSelector(store),
    subscriberCreditCheckStatus: SubscriberCreditCheckStatusSelector(store),
    unvalidatedAddresses: UnvalidatedAddressesSelector(store),
    userSecurityAttributes: UserSecurityAttributesSelector(store),
    validatedAddresses: ValidatedAddressesSelector(store)
  };
};
var controllerActions = {
  createEditCustomerFormChanged: createEditCustomerFormChanged,
  createOrUpdateCustomerAndRunCreditCheck: createOrUpdateCustomerAndRunCreditCheck,
  fetchCodeTypes: fetchCodeTypes,
  overrideCreditClassification: overrideCreditClassification,
  setCreditCheckModalStatus: setCreditCheckModalStatus,
  setCreditCheckSkipped: setCreditCheckSkipped,
  setForceShowEditFormAddress: setForceShowEditFormAddress,
  updateCustomerInfo: updateCustomerInfo,
  updateCustomerInfoEditCopy: updateCustomerInfoEditCopy,
  validateAddress: validateAddress
};
var CreditCheckController = /*#__PURE__*/function () {
  function CreditCheckController($ngRedux, $state, $timeout, uiNotificationService) {
    _classCallCheck(this, CreditCheckController);
    this.$ngRedux = $ngRedux;
    this.$timeout = $timeout;
    this.CREDIT_CHECK_RESULT_SUCCESS_STATUS = CREDIT_CHECK_RESULT_SUCCESS_STATUS;
    this.CREDIT_CHECK_STATUS = CREDIT_CHECK_STATUS;
    this.customerCareKeys = CustomerCareKeys;
    this.customerModelLastSaved = {};
    this.disconnectRedux = null;
    this.flags = {};
    this.formApi = {};
    this.getAddressKey = this.getAddressKey.bind(this);
    this.popupApi = null;
    this.uiNotificationService = uiNotificationService;
    this.staticTranslations = {
      unexpectedError: i18n.translate(this.customerCareKeys.CREDIT_CHECK.UNEXPECTED_ERROR)
    };
    this.validateAddressWithAPI = this.validateAddressWithAPI.bind(this);
  }
  return _createClass(CreditCheckController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.showForm = false; // To show/hide the Customer Form
      this.creditCheckFormErrors = [];
      this.creditCheck = true;
      this.showCreditCheckForm = true; // To show/hide the Override Credit Check section after Credit Check is run or skipped
      this.showCreditClassificationComment = false; // To show/hide the Comment field when the Credit Check is overridden
      this.overrideCreditCheckClassificationID = '';
      this.overrideCreditCheckClassificationComment = '';
      this.creditCheckFailed = false;
      this.creditCheckSuccessFlag = false;
      var onRegisterApi = this.config.onRegisterApi;
      this.config.onRegisterApi = function (_ref) {
        var api = _ref.api;
        _this.popupApi = Object.assign({}, api, {
          open: function open() {
            _this.onModalOpen();
            _this.$timeout(function () {
              api.open();
              _this.formApi.$setPristine();
            });
          }
        });
        onRegisterApi && onRegisterApi({
          api: _this.popupApi
        });
      };
      this.handleFormChanged = function (customerModel) {
        _this.actions.createEditCustomerFormChanged(customerModel);
        if (_this.isNewConnect) {
          _this.actions.updateCustomerInfoEditCopy(customerModel);
        }
      };
      this.handlePropertyChange = function () {
        // Use this placeholder to handle errors if required.
      };
      if (!this.state.addressCountriesLoaded) {
        this.actions.fetchCodeTypes(CODES.AddressCountry);
      }
      if (!this.state.addressStatesLoaded) {
        this.actions.fetchCodeTypes(CODES.AddressStateProvinceRegion);
      }
      this.hasCreditCardUnmaskViewAccess = function () {
        return hasReadAccess(_this.state.userSecurityAttributes, CREDIT_CLASS_VIEW_ACCESS.id);
      };
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "closePopup",
    value: function closePopup() {
      if (this.creditCheckSuccessFlag) {
        if (this.isNewConnect) {
          this.actions.updateCustomerInfo(this.customerModelLastSaved);
        }
        if (this.isChangeOfService && this.isCheckoutStep) {
          this.runChangeOfServiceOrderQuote()();
        } else if (this.isCheckoutStep) {
          this.runOrderQuote()(this.state.selectedCustomerCreditCheckDetails.Subscriber);
        } else if (this.state.subscriberCreditCheckStatus === this.CREDIT_CHECK_STATUS.OVERRIDE) {
          this.uiNotificationService.success(i18n.translate(this.customerCareKeys.CREDIT_CHECK.OVERRIDE_CREDIT_CHECK_SUCCESS), null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
        }
        if (this.onSuccess) {
          this.onSuccess();
        }
      } else if (this.creditCheckFailed) {
        if (this.onError) {
          this.onError();
        }
      } else {
        if (this.onClose) {
          this.onClose();
        }
      }
      if (this.isNewConnect) {
        this.actions.updateCustomerInfoEditCopy(this.customerModelLastSaved);
      }
      this.actions.setCreditCheckModalStatus(false);
      this.showCreditClassificationComment = false;
      this.overrideCreditCheckClassificationComment = '';
      this.showForm = false;
      this.showCreditCheckForm = true;
      this.popupApi.close();
    }
  }, {
    key: "addressStateOptions",
    get: function get() {
      if (this.isNewConnect) {
        return this.state.addressStatesOptions;
      } else {
        return this.state.subscriberAddressStatesOptions;
      }
    }
  }, {
    key: "isFormDirty",
    get: function get() {
      if (this.formApi && this.formApi.createCustomerForm) {
        return this.formApi.createCustomerForm.$dirty;
      } else {
        return false;
      }
    }
  }, {
    key: "onCreditCheckOptionChange",
    value: function onCreditCheckOptionChange() {
      this.actions.setCreditCheckSkipped(!this.creditCheck);
    }
  }, {
    key: "onCreditCheckOverride",
    value: function onCreditCheckOverride() {
      var _this2 = this;
      if (this.overrideCreditCheckClassificationID && this.overrideCreditCheckClassificationComment) {
        var additionalData = {
          updateSubscriber: false,
          creditClassificationData: this.state.subscriberCreditCheckDetails,
          overrideCreditCheckClassificationID: this.overrideCreditCheckClassificationID,
          overrideCreditCheckClassificationComment: this.overrideCreditCheckClassificationComment,
          isDbss: this.state.isDbss
        };
        this.actions.overrideCreditClassification(this.state.createEditCustomer, this.state.subscriberCreditCheckDetails, additionalData).then(function () {
          _this2.overrideCreditCheckClassificationID = '';
          _this2.closePopup();
        }).catch(function (err) {
          _this2.onFailure(err);
        });
      } else if (!this.overrideCreditCheckClassificationID) {
        this.closePopup();
      }
    }
  }, {
    key: "onFailure",
    value: function onFailure(err) {
      this.creditCheckFormErrors.push(err.translatedMessage || this.staticTranslations.unexpectedError);
      this.creditCheckFailed = true;
      this.uiNotificationService.transientError(err.translatedMessage || this.staticTranslations.unexpectedError);
    }
  }, {
    key: "onModalOpen",
    value: function onModalOpen() {
      this.currencyCode = this.customerModel.SubscriberCurrency;
      if (this.state.selectedCustomerCreditCheckDetails.Subscriber) {
        // If Credit Check details already exist for the Customer
        this.currencyCode = this.state.selectedCustomerCreditCheckDetails.Subscriber.SubscriberCurrency;
      } else if (this.state.createEditCustomer) {
        // If New Connect flow
        this.currencyCode = this.state.editCartSelector ? this.state.editCartSelector.customerInfo.SubscriberCurrency : this.customerModel.SubscriberCurrency;
      }
      this.creditCheckFormErrors = [];
      var address = pathOr(null, ['subscriberCreditCheckDetails', 'Address'], this.state);
      var primaryCustomerAddress = null;
      if (address) {
        primaryCustomerAddress = transformAddressResponseObjectForEditing(address);
      } else {
        primaryCustomerAddress = {
          country: this.customerModel.HomeCountry
        };
      }
      var creditCheckAddress = {
        country: this.customerModel.HomeCountry,
        addressLine1: null,
        addressLine2: null,
        city: null,
        stateRegionProvince: null,
        postalCode: null
      };
      if (this.isNewConnect) {
        this.actions.createEditCustomerFormChanged(Object.assign({}, this.customerModel, primaryCustomerAddress, {
          AddressForCreditCheck: creditCheckAddress
        }));
      } else {
        this.actions.createEditCustomerFormChanged(Object.assign({}, this.customerModel, primaryCustomerAddress, {
          AddressForCreditCheck: creditCheckAddress
        }, {
          setEditAdditionalProp: this.customerModel.AdditionalProperties
        }));
      }
      this.customerModelLastSaved = clone(this.customerModel);
      this.showForm = true;
      this.creditCheckSuccessFlag = false;
      this.creditClassificationOptions = this.state.creditCheckClassificationOptions;
      this.actions.setCreditCheckModalStatus(true);
      this.actions.setCreditCheckSkipped(!this.creditCheck);
    }
  }, {
    key: "changeCreditClassification",
    value: function changeCreditClassification(item) {
      this.setCreditClassification(item.id);
      this.setCreditLimitForClassification(item.id);
      if (item.id !== this.assignedCreditClassificationId) {
        this.showCreditClassificationComment = true;
        this.overrideCreditCheckClassificationID = item.id;
      } else {
        this.showCreditClassificationComment = false;
        this.overrideCreditCheckClassificationID = '';
      }
    }
  }, {
    key: "setCreditLimitForClassification",
    value: function setCreditLimitForClassification(item) {
      var classification = this.state.creditClassifications.find(function (classification) {
        return classification.Id === item;
      });
      this.creditLimit = classification ? classification.CreditLimit : i18n.translate(this.customerCareKeys.CREDIT_CHECK.NA);
    }
  }, {
    key: "rerunCreditCheck",
    value: function rerunCreditCheck() {
      var _this3 = this;
      this.showCreditClassificationComment = false;
      this.showCreditCheckForm = true;
      this.overrideCreditCheckClassificationID = '';
      this.$timeout(function () {
        _this3.formApi.$setPristine();
      });
    }
  }, {
    key: "setCreditClassification",
    value: function setCreditClassification(creditClassificationId) {
      this.creditClassificationOptions.forEach(function (item) {
        item.id === creditClassificationId ? item.selected = true : item.selected = false;
      });
    }
  }, {
    key: "handleSubmitForm",
    value: function handleSubmitForm() {
      if (this.showCreditCheckForm) {
        this.runOrSkipCreditCheck();
      } else {
        this.onCreditCheckOverride();
      }
    }
  }, {
    key: "getAddressKey",
    value: function getAddressKey() {
      return pathOr(undefined, ['formApi', 'createCustomerForm', 'addressWrapupController.singleAddressFormFormApi', 'addressKey'], this);
    }
  }, {
    key: "getAddressKeyForAddressValidatedThroughAPI",
    value: function getAddressKeyForAddressValidatedThroughAPI() {
      return pathOr(undefined, ['formApi', 'createCustomerForm', 'addressWrapupController.singleAddressFormFormApi', 'keyForAddressValidatedThroughAPI'], this);
    }
  }, {
    key: "getJobToken",
    value: function getJobToken() {
      var addressKey = this.getAddressKey(),
        addressKeyForAddressValidatedThroughAPI = this.getAddressKeyForAddressValidatedThroughAPI(),
        validatedAddressForCurrentAddress = this.state.validatedAddresses[addressKey],
        validatedAddressForAddressValidatedThroughAPI = this.state.validatedAddresses[addressKeyForAddressValidatedThroughAPI];
      if (validatedAddressForCurrentAddress && validatedAddressForCurrentAddress.JobToken) {
        return validatedAddressForCurrentAddress.JobToken;
      } else if (validatedAddressForAddressValidatedThroughAPI && validatedAddressForAddressValidatedThroughAPI.JobToken) {
        return validatedAddressForAddressValidatedThroughAPI.JobToken;
      }
      return null;
    }
  }, {
    key: "validateAddressWithAPI",
    value: function validateAddressWithAPI() {
      /*
          The address below is being used to populate serviceability address and other areas
          pre-checkout in new connect order flow, which is the reason for the addressTypes
          below
      */
      var addressKey = this.getAddressKey(),
        unvalidatedAddress = this.state.unvalidatedAddresses[addressKey],
        validatedAddress = this.state.validatedAddresses[addressKey],
        addressTypes = {
          DefaultBilling: true,
          DefaultHome: true,
          DefaultPostal: true,
          DefaultService: true
        };
      if (validatedAddress || !unvalidatedAddress) {
        return Promise.resolve(100);
      } else {
        return this.actions.validateAddress(addressKey, unvalidatedAddress, this.getJobToken(), addressTypes);
      }
    }
  }, {
    key: "handleUpdateCreditClassificationResponse",
    value: function handleUpdateCreditClassificationResponse(response) {
      this.assignedCreditClassificationId = response.Subscriber.CreditCheckClassification.CreditCheckClassificationId;
      this.setCreditClassification(this.assignedCreditClassificationId);
      this.setCreditLimitForClassification(this.assignedCreditClassificationId);
      this.showCreditCheckForm = false;
      this.creditCheckSuccessFlag = true;
      this.creditCheckFailed = false;
      this.formApi.$setPristine();
      this.customerModelLastSaved = clone(this.customerModel);
    }
  }, {
    key: "runOrSkipCreditCheck",
    value: function runOrSkipCreditCheck() {
      var _this4 = this;
      var ngFormErrors = this.formApi.createCustomerForm.$error;
      var creditCheckFormNonApErrors = formHasErrors(ngFormErrors, getErrorLookupObject());
      var apFormErrors = this.formApi.createCustomerForm.addlApi ? this.formApi.createCustomerForm.addlApi.$error : null;
      var apErrors = apFormHasErrors(apFormErrors);
      this.creditCheckFormErrors = creditCheckFormNonApErrors.concat(apErrors);
      if (this.creditCheckFormErrors.length === 0 && !this.state.isCreatingCustomer) {
        this.validateAddressWithAPI().then(function () {
          var addressKey = _this4.getAddressKey();
          var validatedAddress = _this4.state.validatedAddresses[addressKey];
          if (!addressKey || validatedAddress && isAddressValidFromAddressResponse(validatedAddress)) {
            if (!_this4.state.subscriberCreditCheckDetails.Subscriber) {
              _this4.actions.createOrUpdateCustomerAndRunCreditCheck(_this4.state.createEditCustomer, _this4.creditCheck, _this4.state.subscriberCreditCheckDetails).then(function (response) {
                _this4.handleUpdateCreditClassificationResponse(response);
              }).catch(function (err) {
                _this4.onFailure(err);
              });
            } else {
              var additionalData = {
                updateSubscriber: _this4.isFormDirty,
                creditClassificationData: _this4.state.subscriberCreditCheckDetails,
                isDbss: _this4.state.isDbss
              };
              _this4.actions.createOrUpdateCustomerAndRunCreditCheck(_this4.state.createEditCustomer, _this4.creditCheck, _this4.state.subscriberCreditCheckDetails, additionalData).then(function (response) {
                _this4.handleUpdateCreditClassificationResponse(response);
              }).catch(function (err) {
                _this4.onFailure(err);
              });
            }
          } else {
            _this4.actions.setForceShowEditFormAddress(false);
            _this4.onFailure({
              //translate and also get guidance from the doc writer
              translatedMessage: i18n.translate(_this4.customerCareKeys.ADDRESS_COMPONENT.INVALID_ADDRESS_ERROR_MESSAGE)
            });
          }
        }).catch(function (err) {
          _this4.onFailure(err);
        });
      }
    }
  }]);
}();
export default {
  template: require('./credit.check.modal.html'),
  bindings: {
    config: '<',
    customerModel: '<',
    formattedSubscriberIdentities: '<?',
    isChangeOfService: '<?',
    isCheckoutStep: '<?',
    isCustomerTypeReadOnly: '<?',
    isNewConnect: '<?',
    isNewCustomer: '<',
    onClose: '&?',
    onError: '&?',
    onSuccess: '&?',
    runChangeOfServiceOrderQuote: '&?',
    runOrderQuote: '&?'
  },
  controllerAs: 'CreditCheckController',
  controller: CreditCheckController
};